import React from 'react'
import { observer } from 'mobx-react'
import InventoryItemForm from '../../components/InventoryItemForm'
import EditInventoryItemViewModel from './EditInventoryItemViewModel'

interface Props {
  vm: EditInventoryItemViewModel
}

function EditInventoryItemDialog({ vm }: Props) {
  return (
    <InventoryItemForm
      vm={vm}
      title="Edit service item"
      submitText="Update item"
      overridden={vm.item?.override}
      editing
    />
  )
}

export default observer(EditInventoryItemDialog)
